export enum Breakpoint {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
  XLarge = 'xlarge',
  XSmall = 'xsmall',
}
